export default {
    PROD: import.meta.env.MODE === "production",
    STAGING: import.meta.env.MODE === "staging",
    DEV: import.meta.env.DEV,

    VITE_API_URL: import.meta.env.VITE_API_URL,

    GRID_INPUT_SPACING: 2.5,
    GRID_SECTION_SPACING: 3.5,

    CURRENCIES: {
        KRONA: new Intl.NumberFormat("sv-SE", { style: "currency", currency: "SEK" }),
        EURO: new Intl.NumberFormat("en", { style: "currency", currency: "EUR" }),
        USD: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }),
    } as const,
};
